import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';

class AuthenticationNetworkFaultConfiguration implements ng.IServiceProvider {
  private configuration: Record<string, boolean> = _4.merge(
    {},
    {
      respondTo404: true,
      respondTo401: true,
      respondTo403: true
    }
  );

  constructor() {
    this.configuration = _4.merge(
      {},
      {
        respondTo404: true,
        respondTo401: true,
        respondTo403: true
      }
    );
  }
  configure(config?: any) {
    if (config) {
      this.configuration = _4.merge({}, this.configuration, config);
    }
    return this.configuration;
  }

  public $get() {
    return {
      configure: (config?: any) => this.configure(config)
    };
  }
}

const authenticationNetworkFaultRun = (
  $state: ng.ui.IStateService,
  loginConfigModel: any,
  ngNetworkFailureConfiguration: any,
  loginConfigurationCommand: ICommand,
  authenticationNetworkFaultConfiguration: AuthenticationNetworkFaultConfiguration
) => {
  const IS_API_REQUEST = /api/i;
  const configuration = authenticationNetworkFaultConfiguration.configure();

  function handleAuthenticationFormErrorResponse(failureResponse: { data: any }) {
    if (location.href.indexOf('authentication') !== -1) {
      let authType = _4.get(loginConfigModel.auth_type, 'loginInterface', '');
      const explicitErrorReason = _4.get(failureResponse, 'data.detail', '');

      if (_4.isEmpty(authType)) {
        loginConfigurationCommand().then(() => {
          authType = _4.get(loginConfigModel.auth_type, 'loginInterface', 'authentication.remote');
          $state.go(`${authType}.failure`, { explicitErrorReason });
        });
      } else {
        $state.go(`${authType}.failure`, { explicitErrorReason });
      }
    }
    return failureResponse;
  }
  function isSameDomain(failureResponseUrl: string) {
    const matches = failureResponseUrl.match(/:\/\/(.[^/]+)/);
    return matches && _4.isEqual(location.hostname, matches[1]);
  }
  if (configuration.respondTo401) {
    ngNetworkFailureConfiguration.onResponseFailure('401', handleAuthenticationFormErrorResponse);
  }

  if (configuration.respondTo403) {
    ngNetworkFailureConfiguration.onResponseFailure('403', handleAuthenticationFormErrorResponse);
  }

  if (configuration.respondTo404) {
    ngNetworkFailureConfiguration.onResponseFailure('404', (failureResponse: { config: ng.IRequestConfig }) => {
      if (IS_API_REQUEST.test(failureResponse.config.url) && isSameDomain(failureResponse.config.url)) {
        sessionStorage.setItem('server_error_response', JSON.stringify(failureResponse));
        $state.go('support', {
          adviceLocation: 'server_error_response'
        });
      }
    });
  }
};

angular
  .module('capability-ng-authentication')
  .provider('authenticationNetworkFaultConfiguration', () => new AuthenticationNetworkFaultConfiguration())
  .run(authenticationNetworkFaultRun);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/config/network_fault_configuration.ts